import { Component, OnInit } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-community',
  imports: [NgbCollapseModule],
  templateUrl: './community.component.html',
  styleUrl: './community.component.scss'
})
export class CommunityComponent implements OnInit{
  
  loading = false;

  debug_active_flow = 'community';
  debug_flows = [
    "community",
    "sender",
    "recipient",
  ]

  activeCampaigns = [
    {
      index: 1,
      isCollapsed: false,
      url: 'https://www.ahealthysliceoflife.com/',
      title: "A Healthy Slice of Life",
      imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_W7Heibe0XchHSJD6OKn4dRkVP5E8gnWI7RFpyy8pyF1Nmp_Ifz6GmBI&s',
      description: 'This is the best article about healthy wealthy skinny',
      campaignImpressions: [
        {
          title: 'Best Travel & Lifestyle Blog In 2024 | A Healthy Slice Of Life',
          description: 'A Healthy Slice Of Life By Brittany Dixon Is The Best Travel & Lifestyle Blog Around! Discover Delicious Recipes, Healthy Living Tips, Family Travel & More.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/09/Arches-National-Park--300x300.jpg',
          url: 'https://www.ahealthysliceoflife.com/',
          isCollapsed: false,
          backlinkSuggestions: [
            {
              suggestionText: "I am very passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop. I am a former health coach and I love sharing my knowledge with others.",
            },
          ]
        },
        {
          title: 'About Brittany Dixon | Family Travel Blog | Visit A Healthy Slice Of Life',
          description: 'Hi, I\'m Brittany! I\'m a former health coach turned homeschooling, work-at-home mom to two energetic girls. In this space I share our life and passion for intentional living through the lens of good food, travel, parenting ups and downs, and our homeschool journey.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/02/about-header.jpg',
          url: 'https://www.ahealthysliceoflife.com/about/',
          backlinkSuggestions: [
            {
              suggestionText: "Though I miss individual health coaching, I love what I am doing now. I love writing about being a mom to my girls and navigating the challenges of healthy living as a busy mom. I am passionate about and <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children.",
            },
          ],
          isCollapsed: false,
        },
        {
          title: 'Milestones - A Healthy Slice of Life',
          description: 'Parenthood is a funny thing. One minute you’re frustrated because your toddler won’t stop jumping on the chair and the next minute you’re weeping thinking about the day she is grown and not there to.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2013/08/h-first-haircut-family-before.jpg',
          url: 'https://www.ahealthysliceoflife.com/milestones/',
          backlinkSuggestions: [
            {
              suggestionText: "I am a former health coach and I love sharing my knowledge with others. I am passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop.",
            },
          ],
          isCollapsed: false,
        },
      ]
    },
    {
      index: 2,
      isCollapsed: true,
      url: 'https://www.collective.com/blog',
      title: 'Collective Blog',
      campaignImpressions: [
        {
          title: 'Collective Blog - Tax Tips, Business Advice & More',
          description: 'Discover expert insights, tips, and resources on taxes, accounting, and business formation for freelancers, solopreneurs, and 1099 employees.',
          imgSrc: 'https://collectivehub.wpenginepowered.com/wp-content/uploads/2022/11/collective-logo-fb.jpg',
          backlinkSuggestions: [
            {
              suggestionText: "Collective is a platform that helps freelancers and solopreneurs manage their finances, taxes, and business formation. It provides tools and resources to simplify the financial aspects of running a business.",
            }
          ],
          isCollapsed: true,
        },
        {
          title: 'Hooman Radfar, Author at Collective',
          description: 'Collective Raises $50M to Become First AI-Powered Finance Platform Designed for Solopreneurs · Blog | Hooman Radfar.',
          imgSrc: 'https://secure.gravatar.com/avatar/74f9728a462aaf505e4a88490c770bc4?s=500&d=mm&r=g',
          backlinkSuggestions: [
            {
              suggestionText: "Hooman Radfar is the co-founder and CEO of Collective, a platform that simplifies finances for freelancers and solopreneurs. He has a background in technology and entrepreneurship.",
            }
          ],
          isCollapsed: true,
        },
        {
          title: 'What is Payroll? | Collective',
          description: 'Learn what payroll is, how it works, and why it\'s vital for your business. Understand payroll processes to ensure accurate employee compensation and compliance.',
          imgSrc: 'https://collectivehub.wpenginepowered.com/wp-content/uploads/2023/08/What-is-Payroll.jpg',
          backlinkSuggestions: [
            {
              suggestionText: "Payroll is the process of compensating employees for their work. It involves calculating wages, withholding taxes, and ensuring compliance with labor laws.",
            }
          ],
          isCollapsed: true,
        },
        {
          title: 'What is a 1099? | Collective',
          description: 'A 1099 form is a tax document used to report income received by independent contractors and freelancers. It helps the IRS track non-employee income for tax purposes.',
          imgSrc: 'https://collectivehub.wpenginepowered.com/wp-content/uploads/2022/11/collective-logo-fb.jpg',
          backlinkSuggestions: [
            {
              suggestionText: "A 1099 form is a tax document used to report income received by independent contractors and freelancers. It helps the IRS track non-employee income for tax purposes.",
            }
          ],
          isCollapsed: true,
        },
      ],
    },
  ]

  recipientImpressions = [
    {
      index: 1,
      title: 'Healthy Wealthy Skinny',
      description: 'A Healthy Slice Of Life By Brittany Dixon Is The Best Travel & Lifestyle Blog Around! Discover Delicious Recipes, Healthy Living Tips, Family Travel & More.',
      imgSrc: 'https://www.healthywealthyskinny.com/wp-content/uploads/2024/07/HWSkinny-141x52.png',
      url: 'https://www.healthywealthyskinny.com',
      isCollapsed: true,
      backlinkSuggestions: [
        {
          title: 'Best Travel & Lifestyle Blog In 2024 | A Healthy Slice Of Life',
          description: 'A Healthy Slice Of Life By Brittany Dixon Is The Best Travel & Lifestyle Blog Around! Discover Delicious Recipes, Healthy Living Tips, Family Travel & More.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/09/Arches-National-Park--300x300.jpg',
          url: 'https://www.ahealthysliceoflife.com/',
          isCollapsed: false,
          backlinkSuggestions: [
            {
              suggestionText: "I am very passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop. I am a former health coach and I love sharing my knowledge with others.",
            },
          ]
        },
        {
          title: 'About Brittany Dixon | Family Travel Blog | Visit A Healthy Slice Of Life',
          description: 'Hi, I\'m Brittany! I\'m a former health coach turned homeschooling, work-at-home mom to two energetic girls. In this space I share our life and passion for intentional living through the lens of good food, travel, parenting ups and downs, and our homeschool journey.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/02/about-header.jpg',
          url: 'https://www.ahealthysliceoflife.com/about/',
          backlinkSuggestions: [
            {
              suggestionText: "Though I miss individual health coaching, I love what I am doing now. I love writing about being a mom to my girls and navigating the challenges of healthy living as a busy mom. I am passionate about and <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children.",
            },
          ],
          isCollapsed: false,
        },
        {
          title: 'Milestones - A Healthy Slice of Life',
          description: 'Parenthood is a funny thing. One minute you’re frustrated because your toddler won’t stop jumping on the chair and the next minute you’re weeping thinking about the day she is grown and not there to.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2013/08/h-first-haircut-family-before.jpg',
          url: 'https://www.ahealthysliceoflife.com/milestones/',
          backlinkSuggestions: [
            {
              suggestionText: "I am a former health coach and I love sharing my knowledge with others. I am passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop.",
            },
          ],
          isCollapsed: false,
        },
      ]
    },
    {
      index: 2,
      title: 'Burger by Bob',
      description: 'A Healthy Slice Of Life By Brittany Dixon Is The Best Travel & Lifestyle Blog Around! Discover Delicious Recipes, Healthy Living Tips, Family Travel & More.',
      imgSrc: 'https://collectivehub.wpenginepowered.com/wp-content/uploads/2022/11/collective-logo-fb.jpg',
      url: 'https://www.thenamelessburger.com',
      isCollapsed: true,
      backlinkSuggestions: [
        {
          title: 'Best Travel & Lifestyle Blog In 2024 | A Healthy Slice Of Life',
          description: 'A Healthy Slice Of Life By Brittany Dixon Is The Best Travel & Lifestyle Blog Around! Discover Delicious Recipes, Healthy Living Tips, Family Travel & More.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/09/Arches-National-Park--300x300.jpg',
          url: 'https://www.ahealthysliceoflife.com/',
          isCollapsed: false,
          backlinkSuggestions: [
            {
              suggestionText: "I am very passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop. I am a former health coach and I love sharing my knowledge with others.",
            },
          ]
        },
        {
          title: 'About Brittany Dixon | Family Travel Blog | Visit A Healthy Slice Of Life',
          description: 'Hi, I\'m Brittany! I\'m a former health coach turned homeschooling, work-at-home mom to two energetic girls. In this space I share our life and passion for intentional living through the lens of good food, travel, parenting ups and downs, and our homeschool journey.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2021/02/about-header.jpg',
          url: 'https://www.ahealthysliceoflife.com/about/',
          backlinkSuggestions: [
            {
              suggestionText: "Though I miss individual health coaching, I love what I am doing now. I love writing about being a mom to my girls and navigating the challenges of healthy living as a busy mom. I am passionate about and <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children.",
            },
          ],
          isCollapsed: false,
        },
        {
          title: 'Milestones - A Healthy Slice of Life',
          description: 'Parenthood is a funny thing. One minute you’re frustrated because your toddler won’t stop jumping on the chair and the next minute you’re weeping thinking about the day she is grown and not there to.',
          imgSrc: 'https://www.ahealthysliceoflife.com/wp-content/uploads/2013/08/h-first-haircut-family-before.jpg',
          url: 'https://www.ahealthysliceoflife.com/milestones/',
          backlinkSuggestions: [
            {
              suggestionText: "I am a former health coach and I love sharing my knowledge with others. I am passionate about <a class='backlink-highlight' href='#'>healthy eating</a>, especially for children. Kids require a lot of nutrients to grow and develop.",
            },
          ],
          isCollapsed: false,
        },
      ]
    }
  ]

  public analyticsCards: any[] = []

  constructor() {
    this.debug_active_flow = this.debug_flows[2]
  }


  articles = [
    {
      title: 'Article 1',
      content: 'Content 1',
      backlinkSample: [
        {
          title: 'Backlink 1',
          url: 'https://www.google.com',
          anchor: 'Google'
        },
      ]
    }
  ] 
  

  ngOnInit() {
    console.log('CommunityComponent');
    this.setupAnalyticsCards();
  }

    setupAnalyticsCards() {
      this.analyticsCards = [];
      this.analyticsCards.push({
        Title: "Open Requests",
        Template: "AnalyticsNumericTemplate",
        Value: 5
      });
      this.analyticsCards.push({
        Title: "Featured Impressions",
        Template: "AnalyticsNumericTemplate",
        Value: 34
      });
      this.analyticsCards.push({
        Title: "Engagements",
        Template: "AnalyticsNumericTemplate",
        Value: 14
      });
    }

  toggleAccordian(campaign) {
    this.activeCampaigns.forEach(c => {
      if(c.index === campaign.index) {
        c.isCollapsed = !c.isCollapsed;
      } else {
        c.isCollapsed = true;
      }
    })
  }

  toggleInboxAccordian(impression) {
    this.recipientImpressions.forEach(c => {
      if(c.index === impression.index) {
        c.isCollapsed = !c.isCollapsed;
      } else {
        c.isCollapsed = true;
      }
    })
  }

  toggleSuggestion(suggestion) {
    suggestion.isCollapsed = !suggestion.isCollapsed;
    // this.activeCampaigns.forEach(c => {
    //   if(c.index === campaign.index) {
    //     c.isCollapsed = !c.isCollapsed;
    //   } else {
    //     c.isCollapsed = true;
    //   }
    //})
  }

  switchPersona(){
    // Switch to next flow in flow list
    const currentIndex = this.debug_flows.indexOf(this.debug_active_flow);
    const nextIndex = (currentIndex + 1) % this.debug_flows.length;
    this.debug_active_flow = this.debug_flows[nextIndex];
    console.log('switchPersona', this.debug_active_flow);
  }

  openSendModal(event:Event, campaign) {
    event.stopPropagation()
    console.log('openSendModal', campaign);
  }
}
0